import { JsonapiEntity, attribute } from '@talisdev/jsonapi-transformers';

export class HierarchyNode extends JsonapiEntity<HierarchyNode> {
  @attribute() code: string;
  @attribute() node_type: string;
  @attribute() student_numbers?: number;
  @attribute() title: string;
  @attribute() description: string | null;

  get htmlPageUrl(): string {
    return `/${this.type}/${this.id.toLowerCase()}`;
  }

  /**
   * Get the normalised JSON:API type for this node.
   *
   * The normalised type will be the same as `type` for most subtypes, except Node.
   *
   * @return {string} The normalised type of this hierarchy node
   */
  get normalisedType(): string {
    return this.type;
  }
}
